<!--
  qualityCaseToDoDetails: to-do of a QM-Cockpit case (source qualityCase): type tag, summary and "Im QM-Cockpit öffnen"
  (only for users who can read cases; never for teachers). The workflow-manager completes the to-do when the case is decided.
-->
<template>
  <div :class="{ 'qc-todo--dense': dense }" class="qc-todo">
    <div class="d-flex flex-wrap align-center" style="gap: 6px">
      <span :class="`tone-${meta.tone}`" class="tag tag--sm"><v-icon class="tag__icon" x-small>{{ meta.icon }}</v-icon>{{ meta.text }}</span>
      <span v-if="source.summary" class="acq-muted qc-todo__text">{{ source.summary }}</span>
    </div>
    <div v-if="!dense && link" class="qc-todo__actions">
      <router-link :to="link" class="cta cta--primary" @click.native.stop>
        <v-icon class="cta__icon" small>mdi-shield-check-outline</v-icon>Im QM-Cockpit öffnen
      </router-link>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import {RawLocation} from 'vue-router';
import {QualityCaseToDoSource} from '@/documentTypes/to-do-manager/ToDoItemSource';
import {qualityCaseLocation, qualityCaseSourceOf} from '@/components/toDos/qualityCaseToDo.helper';
import {QualityCaseType} from '@/enums/workflow-manager/QualityCase.enum';
import {TYPE_META} from '@/components/qualityCockpit/qualityCockpit.helper';
import {Tone} from '@/components/earlyWarning/earlyWarning.helper';

export default Vue.extend({
  props: {
    item: {type: Object as () => { source?: unknown }, required: true},
    dense: {type: Boolean, default: false},
  },
  computed: {
    source(): QualityCaseToDoSource {
      return qualityCaseSourceOf(this.item as never) as QualityCaseToDoSource;
    },
    meta(): { text: string; icon: string; tone: Tone } {
      const meta = TYPE_META[this.source.caseType as QualityCaseType];
      return meta ? {text: `QM · ${meta.text}`, icon: meta.icon, tone: meta.tone} : {text: 'QM-Cockpit', icon: 'mdi-shield-check-outline', tone: 'info'};
    },
    link(): RawLocation | null {
      return qualityCaseLocation(this.source);
    },
  },
});
</script>

<style scoped>
.qc-todo {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  margin-top: 2px;
}

.qc-todo--dense {
  gap: 2px;
}

.qc-todo__text {
  font-size: 13px;
  line-height: 1.4;
  overflow-wrap: anywhere;
}

.qc-todo__actions .cta {
  height: 32px;
  text-decoration: none;
}
</style>
<style src="@/components/acquisitionList/ui/acquisitionViews.css"></style>
<style src="@/components/common/modern/modern.css"></style>
